import { Typography } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'

import {
  TicketPriority as Priority,
  ticketPriorityLabel
} from '../../helpers/ticketWorkflow'
import useStyles from './styles/SupportTicketsTable.styles'

interface TicketPriorityProps {
  priority: Priority
}

/**
 * Priority as a leading stripe plus its value.
 *
 * ONE component for both surfaces rather than a cell in each. The desktop row
 * and the mobile card duplicate LAYOUT by design, but a severity indicator is
 * behaviour — an operator who learns that red means P1 on one surface must not
 * meet a different convention on the other, and two copies is how that happens.
 *
 * The value is always rendered as text. The stripe is redundant reinforcement,
 * not the signal: colour alone fails WCAG 1.4.1, and this list is read in Farsi
 * where an inherited colour convention carries less than the literal P-value
 * agents already say out loud.
 */
export default function TicketPriority({ priority }: TicketPriorityProps) {
  const classes = useStyles()
  const tone = {
    P1: classes.priorityP1,
    P2: classes.priorityP2,
    P3: classes.priorityP3,
    P4: classes.priorityP4
  }[priority]

  return (
    <span className={classes.priorityCell}>
      {/* aria-hidden: the stripe says nothing the adjacent text does not, and
          announcing an unlabelled decorative span before every value is noise
          in a forty-row list. */}
      <span className={clsx(classes.priorityStripe, tone)} aria-hidden="true" />
      <Typography variant="body2">
        <bdi dir="ltr">{ticketPriorityLabel(priority)}</bdi>
      </Typography>
    </span>
  )
}
